import { z } from 'zod';
import { ATTENDANCE_LIMITS, ATTENDANCE_MARKS, } from '../attendance.js';
/**
 * CHẤM CÔNG (05/10/2026) — hợp đồng giữa web và máy chủ. Luật tính đúng giờ / muộn / về sớm nằm ở
 * `attendance.ts` (gói shared), hai bên cùng gọi.
 */
/** Tham số lặp (?month=a&month=b) → lấy giá trị ĐẦU, như các truy vấn khác. */
const queryText = z.preprocess((value) => (Array.isArray(value) ? value[0] : value), z.string().max(64).optional());
/**
 * `?month=YYYY-MM` (cả tháng), `?date=YYYY-MM-DD` (một ngày), hoặc `?from=&to=` (khoảng ngày tuỳ ý, tối đa
 * `ATTENDANCE_LIMITS.rangeDays` ngày — tab «Lịch sử» của bản bàn giao 07/10/2026: «lọc theo khoảng ngày»).
 */
export const attendanceRangeQuerySchema = z.object({
    month: queryText,
    date: queryText,
    from: queryText,
    to: queryText,
});
export const attendanceMarkSchema = z.object({
    username: z.string().trim().min(1).max(64),
    /** Ngày «YYYY-MM-DD» theo giờ Việt Nam. */
    day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    /** `null` = bỏ dấu tay, ngày ấy lại tính theo các lần chấm. */
    code: z.enum(ATTENDANCE_MARKS).nullable(),
    note: z.string().trim().max(200).default(''),
});
/**
 * GHI CHÚ của quản lý cho một người một ngày (05/10/2026, chủ dự án: «thêm cột ghi chú»). `note` rỗng = xoá.
 * Cùng quyền với dấu tay; khác dấu tay ở chỗ KHÔNG đổi cách tính công.
 */
export const attendanceNoteSchema = z.object({
    username: z.string().trim().min(1).max(64),
    day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    note: z.string().trim().max(ATTENDANCE_LIMITS.note).default(''),
});
/**
 * Bấm «Vào ca» / «Ra ca». `kind` là nút đã bấm (bản bàn giao 07/10/2026; app bản cũ không gửi → lần chấm chia
 * cho mốc theo giờ). `reason` chỉ cần khi vào ca TRỄ — máy chủ đòi thì mới gửi. `fromApp`: trang đang chạy như app
 * mở từ màn hình chính (không phải thẻ trình duyệt) — xem `punchDeviceAllowed`; app bản cũ không gửi.
 */
export const attendancePunchSchema = z.object({
    kind: z.enum(['in', 'out']).optional(),
    reason: z.string().trim().max(200).default(''),
    fromApp: z.boolean().optional(),
});
/** Số ngày của mục «7 ngày gần đây» ở màn chấm công (gồm hôm nay). */
export const ATTENDANCE_RECENT_DAYS = 7;
//# sourceMappingURL=attendance.js.map